import { PaymentMethod } from '../PaymentMethod/PaymentMethod';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { AVILABLE_PAYMENT_METHOD_COUNT } from '@/constants/payment';
import { PaymentMethodEnum } from '@/types/common';

export const PaymentMethods = () => {
  const { paymentMethodsAvailable } = useContext(CheckoutContext);
  return (
    <div data-testid="payment-methods-list" className="flex flex-row justify-between gap-2">
      {paymentMethodsAvailable
        .filter((pm) => !pm.isExpress)
        .slice(0, AVILABLE_PAYMENT_METHOD_COUNT)
        .map((pm) => (
          <PaymentMethod key={pm.paymentMethodName} paymentMethod={pm.paymentMethodName as PaymentMethodEnum} />
        ))}
    </div>
  );
};
